// document.addEventListener('DOMContentLoaded', function () {
//   var popup = document.getElementById('custom-page-popup');
//   var closeBtn = document.getElementById('custom-popup-close');
//   var popupLink = document.getElementById('custom-popup');
//   if (!popup) return;
//   var SESSION_KEY = 'popup_session_state';
//   var SUPPRESSION_KEY = 'popup_suppressed_until';
//   var currentPath = window.location.pathname.toLowerCase();
//   if (
//     currentPath === '/cart' ||
//     currentPath.indexOf('/cart/') === 0 ||
//     currentPath.indexOf('/checkout') === 0
//   ) {
//     return;
//   }
//   function getState() {
//     try {
//       return JSON.parse(
//         sessionStorage.getItem(SESSION_KEY)
//       ) || {
//         pageviews: 0,
//         quizShown: false,
//         quizCompleted: false,
//         quizDismissed: false,
//         emailShown: false
//       };

//     } catch (e) {
//       return {
//         pageviews: 0,
//         quizShown: false,
//         quizCompleted: false,
//         quizDismissed: false,
//         emailShown: false
//       };
//     }
//   }
//   function saveState(state) {
//     sessionStorage.setItem(
//       SESSION_KEY,
//       JSON.stringify(state)
//     );

//   }
//   function isSuppressed() {
//     var until = parseInt(
//       localStorage.getItem(SUPPRESSION_KEY) || '0',
//       10
//     );
//     return Date.now() < until;
//   }
//   function suppressFor7Days() {
//     var sevenDays =
//       7 * 24 * 60 * 60 * 1000;
//     localStorage.setItem(
//       SUPPRESSION_KEY,
//       String(Date.now() + sevenDays)
//     );
//   }
//   var state = getState();
//   state.pageviews++;
//   saveState(state);
//   if (state.pageviews === 1) {
//     return;
//   }
//   if (isSuppressed()) {
//     return;
//   }
//   function showQuiz() {
//     var state = getState();
//     if (state.emailShown) {
//       return;
//     }
//     if (state.quizCompleted) {
//       return;
//     }
//     if (isSuppressed()) {
//       return;
//     }
//     state.quizShown = true;
//     saveState(state);
//     popup.classList.add('active');
//   }
//   function hideQuiz() {
//     popup.classList.remove('active');
//     var state = getState();
//     state.quizDismissed = true;
//     saveState(state);
//   }
//   if (closeBtn) {
//     closeBtn.addEventListener('click', function (e) {
//       e.preventDefault();
//       hideQuiz();
//     });
//   }
//   popup.addEventListener('click', function (e) {
//     if (e.target === popup) {
//       hideQuiz();
//     }
//   });
//   if (popupLink) {
//     popupLink.addEventListener('click', function () {
//       popup.classList.remove('active');
//     });
//   }
//   window.customQuizSubmitted = function () {
//     var state = getState();
//     state.quizCompleted = true;
//     saveState(state);
//     suppressFor7Days();
//     popup.classList.remove('active');
//     hideKlaviyoPopup();
//   };
//   function getKlaviyoPopup() {
//     var form = document.querySelector(
//       '[data-testid="klaviyo-form-RSpYZZ"]'
//     );
//     if (!form) return null;
//     return form.closest(
//       '[role="dialog"][aria-modal="true"]'
//     );
//   }
//   function hideKlaviyoPopup() {
//     var klaviyoPopup = getKlaviyoPopup();
//     if (klaviyoPopup) {
//       klaviyoPopup.style.display = 'none';
//     }
//   }
//   function shouldBlockKlaviyo() {
//     var state = getState();
//     if (state.quizCompleted) {
//       return true;
//     }
//     if (isSuppressed()) {
//       return true;
//     }
//     return false;
//   }
//   var observer = new MutationObserver(function () {
//     var state = getState();
//     var klaviyoPopup = getKlaviyoPopup();
//     if (!klaviyoPopup) {
//       return;
//     }
//     if (shouldBlockKlaviyo()) {
//       hideKlaviyoPopup();
//       return;
//     }
//     if (
//       popup.classList.contains('active')
//     ) {
//       hideKlaviyoPopup();
//       return;
//     }
//     if (!state.emailShown) {
//       state.emailShown = true;
//       saveState(state);
//     }
//   });
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
//   setTimeout(function () {
//     var state = getState();
//     if (
//       state.pageviews >= 2 &&
//       !state.quizShown &&
//       !state.emailShown &&
//       !state.quizCompleted &&
//       !isSuppressed()
//     ) {
//       showQuiz();
//     }
//   }, 15000);
// });

document.addEventListener('DOMContentLoaded', function () {

  if (window.__popupFlowInitialized) {
    console.warn('Popup script already running — duplicate load blocked.');
    return;
  }
  window.__popupFlowInitialized = true;

  var popup = document.getElementById('custom-page-popup');
  var closeBtn = document.getElementById('custom-popup-close');
  var popupLink = document.getElementById('custom-popup');

  var SESSION_KEY = 'popup_session_state';
  var QUIZ_SUPPRESSION_KEY = 'popup_suppressed_until';       
  var EMAIL_SUPPRESSION_KEY = 'popup_email_suppressed_until'; 
  var KLAVIYO_FORM_ID = 'RSpYZZ';

  var EMAIL_DELAY_MS = 3000;        
  var QUIZ_AFTER_EMAIL_MS = 1000;   
  var KLAVIYO_WAIT_MAX_MS = 5000;
  var DIALOG_APPEAR_MAX_MS = 5000;  

  var currentPath = window.location.pathname.toLowerCase();
  var blockedPage =
    currentPath === '/' ||
    currentPath === '/cart' ||
    currentPath.indexOf('/cart/') === 0 ||
    currentPath.indexOf('/checkout') === 0;

  if (popup) {
    popup.classList.remove('active');
  }

  if (blockedPage) {
    return;
  }

  /* ---------- State helpers ---------- */

  function getDefaultState() {
    return {
      quizShown: false,
      quizCompleted: false,
      quizDismissed: false,
      signInShown: false,
      signInSubmitted: false,
      pageLoadTime: Date.now()
    };
  }

  function saveState(state) {
    try {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(state));
    } catch (e) {}
  }

  function getState() {
    try {
      var saved = sessionStorage.getItem(SESSION_KEY);
      var parsed = saved ? JSON.parse(saved) : null;
      if (!parsed || !parsed.pageLoadTime) {
        var fresh = getDefaultState();
        saveState(fresh);
        return fresh;
      }
      return parsed;
    } catch (e) {
      var fallback = getDefaultState();
      saveState(fallback);
      return fallback;
    }
  }

  function isSuppressed(key) {
    try {
      var until = parseInt(localStorage.getItem(key) || '0', 10);
      return Date.now() < until;
    } catch (e) {
      return false;
    }
  }

  function suppressFor7Days(key) {
    try {
      var sevenDays = 7 * 24 * 60 * 60 * 1000;
      localStorage.setItem(key, String(Date.now() + sevenDays));
    } catch (e) {}
  }


  var quizScheduled = false;

  function showQuiz() {
  if (!popup) return;
  var state = getState();

  if (state.quizShown) return;
  if (state.quizCompleted) return;
  if (state.quizDismissed) return;
  if (isSuppressed(QUIZ_SUPPRESSION_KEY)) return;
  if (popup.classList.contains('active')) return;

  state.quizShown = true;
  saveState(state);
  popup.classList.add('active');
}

 function hideQuiz() {
  if (!popup) return;
  popup.classList.remove('active');
  var state = getState();
  state.quizDismissed = true;
  saveState(state);
  suppressFor7Days(QUIZ_SUPPRESSION_KEY); // optional
}

  function scheduleQuiz() {
    if (quizScheduled) return;
    quizScheduled = true;
    setTimeout(showQuiz, QUIZ_AFTER_EMAIL_MS);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      hideQuiz();
    });
  }

  if (popup) {
    popup.addEventListener('click', function (e) {
      if (e.target === popup) {
        hideQuiz();
      }
    });
  }

  if (popupLink) {
    popupLink.addEventListener('click', function () {
      popup.classList.remove('active');
    });
  }

  window.customQuizSubmitted = function () {
    var state = getState();
    state.quizCompleted = true;
    saveState(state);
    suppressFor7Days(QUIZ_SUPPRESSION_KEY);
    if (popup) {
      popup.classList.remove('active');
    }
  };


  var emailTriggered = false;
  var emailFlowDone = false;

  function onEmailFlowDone() {
    if (emailFlowDone) return;
    emailFlowDone = true;
    scheduleQuiz();
  }

  function watchKlaviyoDismiss() {
    var seen = false;
    var startedAt = Date.now();

    var checkInterval = setInterval(function () {
      var dialog = document.querySelector('[role="dialog"][aria-label="POPUP Form"]');

      if (dialog) {
        seen = true;
        return;
      }

      if (seen) {
        clearInterval(checkInterval);
        var state = getState();
        if (!state.signInSubmitted) {
          suppressFor7Days(EMAIL_SUPPRESSION_KEY);
        }
        onEmailFlowDone();
        return;
      }

      if (Date.now() - startedAt > DIALOG_APPEAR_MAX_MS) {
        clearInterval(checkInterval);
        onEmailFlowDone();
      }
    }, 500);

    setTimeout(function () {
      clearInterval(checkInterval);
    }, 300000);
  }

  function openKlaviyoSignIn() {
    if (emailTriggered) return;

    var state = getState();

    if (state.signInSubmitted || isSuppressed(EMAIL_SUPPRESSION_KEY)) {
      emailTriggered = true;
      onEmailFlowDone();
      return;
    }

    var waited = 0;

    function tryOpen() {
      if (
        typeof window.klaviyo === 'undefined' ||
        typeof window.klaviyo.openForm !== 'function'
      ) {
        waited += 500;
        if (waited >= KLAVIYO_WAIT_MAX_MS) {
          emailTriggered = true;
          onEmailFlowDone();
          return;
        }
        setTimeout(tryOpen, 500);
        return;
      }

      emailTriggered = true;
      var s = getState();
      s.signInShown = true;
      saveState(s);
      window.klaviyo.openForm(KLAVIYO_FORM_ID);
      watchKlaviyoDismiss();
    }

    tryOpen();
  }

  window.addEventListener('klaviyoForms', function (event) {
    if (!event.detail) return;
    if (event.detail.formId === KLAVIYO_FORM_ID && event.detail.type === 'submit') {
      var state = getState();
      state.signInShown = true;
      state.signInSubmitted = true;
      saveState(state);
      suppressFor7Days(EMAIL_SUPPRESSION_KEY);
    }
  });

  setTimeout(openKlaviyoSignIn, EMAIL_DELAY_MS);

});